<div class="star" (click)="onClick()">
  <i class="fa-star fa-regular" [ngClass]="{'show' : !favorite}"></i>
  <i class="fa-star fa-solid" [ngClass]="{'show' : favorite}"></i>
</div>
